import axios from "axios";


export const baseUrl = "https://df.web-sayt.uz/"
const instance = axios.create({
  baseURL: baseUrl + "api/"
});
if(typeof window !== 'undefined') {
    instance.defaults.headers.common['Authorization'] = `Bearer ${localStorage.getItem('token')}`;
}
export default instance;